module.exports = __webpack_public_path__ + "img/mqttDTU1.68d32a15.jpg";